import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useAuth } from "../../../providers/AuthProvider";

export type Brand = { id: string; name: string; status: string | null };

export function useBrands() {
  const { token } = useAuth();
  const [rows, setRows] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!token) {
      setRows([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await api.brands.list({ token });
      setRows(res.data);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load brands");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { brands: rows, loading, error, reload };
}

